/* flow */

var cleanStateKey = function cleanStateKey(key) {
  return key === null || typeof key === 'undefined' ? 'main' : key.toString();
};

export default cleanStateKey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/radium/es/clean-state-key.js
// module id = 50
// module chunks = 0